export default {
    url: '/detail/:id',
    template: '<courses-fields-detail field="vm.field"/>',
    resolve: {
        field (ClassifierResource, $stateParams) {
            return ClassifierResource.get({ id: $stateParams.id, expand: 'classifierI18ns,activeI18n' }).$promise;
        }
    },
    controller (field) {
        this.field = field;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/fields/detail/index.js